import CheckedMixin from './ui/mixins/CheckedMixin';
import ClickableMixin from './ui/mixins/ClickableMixin';
import CollapsedMixin from './ui/mixins/CollapsedMixin';
import ContainableMixin from './ui/mixins/ContainableMixin';
import DisabledMixin from './ui/mixins/DisabledMixin';
import FocusMixin from './ui/mixins/FocusMixin';
import HiddenCollapsedMixin from './ui/mixins/HiddenCollapsedMixin';
import HiddenMixin from './ui/mixins/HiddenMixin';
import LabelMixin from './ui/mixins/LabelMixin';
import LinkableMixin from './ui/mixins/LinkableMixin';
import PlayableMixin from './ui/mixins/PlayableMixin';
import ReadOnlyMixin from './ui/mixins/ReadOnlyMixin';
import RequiredMixin from './ui/mixins/RequiredMixin';
import TextInputMixin from './ui/mixins/TextInputMixin';
import ValidatableMixin from './ui/mixins/ValidatableMixin';
import ValueMixin from './ui/mixins/ValueMixin';
import ViewportMixin from './ui/mixins/ViewportMixin';
import { default as StyleMixin, registerStyleMixinComponent} from './ui/mixins/styleMixins/StyleMixin';
import BackgroundColorMixin from './ui/mixins/styleMixins/BackgroundColorMixin';
import ForegroundColorMixin from './ui/mixins/styleMixins/ForegroundColorMixin';
import BorderColorMixin from './ui/mixins/styleMixins/BorderColorMixin';
import BorderRadiusMixin from './ui/mixins/styleMixins/BorderRadiusMixin';
import BorderWidthMixin from './ui/mixins/styleMixins/BorderWidthMixin';
import styleService from './ui/mixins/styleMixins/styleService';
import TextColorMixin from './ui/mixins/styleMixins/TextColorMixin';
import AnimatableMixin from './ui/mixins/AnimatableMixinStub.es6';

function mixin (receiver, supplier) {
    const propsNames = Object.getOwnPropertyNames(supplier);
    propsNames.forEach((property) => {
        if (supplier.hasOwnProperty(property) && property !== 'constructor') {
            Object.defineProperty(receiver, property, Object.getOwnPropertyDescriptor(supplier, property));
        }
    });

    return receiver;
}

export {
    mixin,
    CheckedMixin,
    ClickableMixin,
    CollapsedMixin,
    ContainableMixin,
    DisabledMixin,
    FocusMixin,
    HiddenCollapsedMixin,
    HiddenMixin,
    LabelMixin,
    LinkableMixin,
    PlayableMixin,
    ReadOnlyMixin,
    RequiredMixin,
    TextInputMixin,
    ValidatableMixin,
    ValueMixin,
    ViewportMixin,
    StyleMixin,
    BackgroundColorMixin,
    ForegroundColorMixin,
    BorderColorMixin,
    BorderRadiusMixin,
    BorderWidthMixin,
    styleService,
    registerStyleMixinComponent,
    TextColorMixin,
    AnimatableMixin
};
